<div id="crop-health-map-calendar">
  <div class="slidesContainer" #slidesContainerEl>
    <swiper-container
      #swiper
      navigation="false"
      pagination="false"
      scrollbar="false"
      slides-per-view="6"
      space-between="10"
      centered-slides="false"
      [class.full-screen]="fullScreenMode">
      @for (item of slides; track item.imageDate?.toMillis(); let index = $index) {
        <swiper-slide (click)="onSelectDay(index)" [class.selected-slide]="selectedDayIndex === index">
          <span class="slide" [class.selected]="selectedDayIndex === index">
            @if (!item.isCloudly && item.imageUrl) {
              <img class="img-placeholder" [src]="item.imageUrl" alt="" />
            } @else {
              <div class="img-placeholder"></div>
            }
            @if (item.isCloudly) {
              <span class="cloud"> ☁️ </span>
            }
            @if (selectedMapType?.key === 'risk' && isThereProblematicSpot(item.imageDate)) {
              <span class="problematic-spot">
                <span></span>
              </span>
            }
            <span class="date"> {{ item.imageDate | luxonFormat: 'dd LLL': ('UTC'+ plantationService.selectedPlantation.offSet) }} </span>
            <span class="ndvi-value"
              >{{ selectedMapType?.key | uppercase}} {{ item.averangeValue.toFixed(2) }}</span
            >
          </span>
        </swiper-slide>
      }

      @if (isThereMoreToLoad) {
        <swiper-slide (click)="loadMore.emit()">
          <span class="slide download">
            <i class="ph-fill ph-download-simple"></i>
          </span>
        </swiper-slide>
      }
    </swiper-container>
  </div>
  <div class="btns">
    @if (slides?.length > 0) {
      <span class="caret" [class.disabled]="selectedDayIndex === 0" (click)="previousDay()">
        <i class="ph-bold ph-caret-left"></i>
      </span>
      <span class="caret" [class.disabled]="selectedDayIndex === slides.length - 1" (click)="nextDay()">
        <i class="ph-bold ph-caret-right"></i>
      </span>
    }

    <div class="calendar" (click)="openCalendarModal()">
      <i class="ph ph-calendar-dots"></i>
    </div>
  </div>
</div>
